import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MainTable from "../../../../components/Table/PaginationTable";
import DownloadButton from "../../../../components/common components/DownloadButton";
import FilterPanel from "../../../../components/common components/FilterPanel";
// import LinkedOrdersModal from '../../Orders/Outbox/LinkedOrderModal'
import { PendingCompanyColumns } from "../../columns/columns";
import {
  deleteCompanyById,
  fetchPendingCompany,
} from "../../../../redux/adminSlice";
import WarningShipmentModalComponent from "../../../../components/Modals/WarningShipmentModalComponent";
import FilterPanelForCompanies from "../../../../components/common components/FilterPanelForCompanies";

const PendingOrders = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableData =
    useSelector((state) => state.admin.pendingCompanyData) || []; // console.log("****",state.order.data
  const isLoading = useSelector((state) => state.admin.loading);
  const isError = useSelector((state) => state.admin.error);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [filterCriteria, setFilterCriteria] = useState({
    search: "",
    fromDate: "",
    toDate: "",
  });
  // const { data, loading, error } = useSelector((state) => state.tableData); // Assuming the state shape
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const totalRecords =
    useSelector((state) => state.admin.paginationInfo?.totalRecords) || 0;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteCompanyId, setDeleteCompanyId] = useState("");

  useEffect(() => {
    console.log(
      `Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber},`
    ); // ${token}
    // dispatch(resetOrderState())
    const queryParams = {
      type: "pending",
      pageSize,
      pageNumber,
      approvalStatus: 2,
      // searchText:''
    };
    // dispatch(fetchPendingCompany(queryParams));
    // resetCompaniesState()
  }, [dispatch, pageSize, pageNumber]);

  //===================Handle Methods ===============================

  const handleReset = () => {
    dispatch(
      fetchPendingCompany({
        type: "pending",
        pageSize,
        pageNumber,
        approvalStatus: 2,
        country: "",
        companyTypeName: "",
      })
    );
    console.log("Filter criteria reset");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const deletecompFun = () => {
    // console.warn("In Delete", businessUnitId, actionType)
    dispatch(deleteCompanyById({ companyId: deleteCompanyId }))
      .then((response) => {
        if (response) {
          dispatch(
            fetchPendingCompany({
              type: "pending",
              pageSize,
              pageNumber,
              approvalStatus: 2,
              country: "",
              companyTypeName: "",
            })
          );
        }
        // console.log('deleted successfully:', response);
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
      });
  };

  const pendingViewFun = (companyId, actionType) => {
    navigate(`/review-pending-orders/${companyId}`); // Navigate to create order page
  };
  // Function to handle filter action
  const handleFilter = (criteria) => {
    console.log("check",criteria)
    const formattedCriteria = {
      searchText: criteria.search,
      country:criteria.countries.join(','),
      companyTypeId:criteria.companyTypeId,
      status:criteria.status,
      // fromDate: criteria.fromDate ? dayjs(criteria.fromDate).format('YYYY-MM-DD') : '',
      // toDate: criteria.toDate ? dayjs(criteria.toDate).format('YYYY-MM-DD') : ''
    };
    setFilterCriteria(formattedCriteria);
    // Perform filtering logic based on criteria
    console.log('Filter criteria:', criteria);
    const queryParams = {
      type: "pending",
      pageSize,
      pageNumber,
      approvalStatus: formattedCriteria.status,
      country: formattedCriteria.country,
      companyTypeName: formattedCriteria.companyTypeId,
      searchText: formattedCriteria.searchText
    };
    dispatch(fetchPendingCompany(queryParams));
  };
  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };
  // TO Delete  from the card
  const onDeleteCompnyBtnClick = (companyId, actionType) => {
    setIsDeleteModalOpen(true);
    setDeleteCompanyId(companyId);
  };
  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };
  const pendingColumns = PendingCompanyColumns(
    pendingViewFun,
    isCancelModalOpen,
    onDeleteCompnyBtnClick,
    t
  );
  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
            {/* <button className="btn btn-primary greeen-btn md_btn" onClick={handleCreateOrderBtnClick}>
              <span><i className="mdi mdi-plus-circle-outline"></i></span> {t('orderOutboxcomponents.createNew')}
            </button> */}
          </div>
          <div>
            {/* <DownloadButton
              data={tableData}
              filename="Outgoing Order List.xlsx"
              sheetname="Order List"
              forModule="Order"
            /> */}
            {/* <FilterPanel onFilter={handleFilter} onReset={handleReset} /> */}
            <button
              className="btn btn-light grey-btn md_btn me-0"
              onClick={() => setIsFilterPanelOpen((prevState) => !prevState)}
            >
              <span>
                <i className="bi bi-funnel"></i>
              </span>{" "}
              {t("orderOutboxcomponents.filters")}
              {/* <button className="btn btn-primary greeen-btn md_btn">
              <span><i className="mdi mdi-file-document"></i></span>{t('btnGrpText.downloadOrders')}
            </button> */}
            </button>
          </div>
        </div>
      </div>
      {isFilterPanelOpen && <FilterPanelForCompanies className='mb-3' onFilter={handleFilter} onReset={handleReset} />}

      <MainTable
        columns={pendingColumns}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        // className="custom-table-class"
        recordCountText="total records"
      />
      {/* {linkModalOpen && <LinkedOrdersModal
        open={linkModalOpen}
        onClose={handleLinkCloseModal}
        actionType={actionType}
        newOrderId={newOrderId}
        linkedOrderList={linkedOrderList}
      />} */}
      {/* {isReasonModalOpen && <ReasonModalComponent'
      /
      
       open={isReasonModalOpen}
       handleClose={handleReasonCloseModal}
       action={actionType}
       reasonData={reasonData}
    />} */}
      {isDeleteModalOpen && (
        <WarningShipmentModalComponent
          isOpen={isDeleteModalOpen}
          onClose={onDeleteModalClose}
          handleDelete={deletecompFun}
        />
      )}
    </>
  );
};

export default PendingOrders;
